import React from 'react';
import { Box, Button, Typography, List, ListItem } from '@mui/material';
import Modal from 'components/_layouts/Modal';
import { translate as t } from 'hooks/useTranslations';

export default function AccessLevelModal({
  isHelpOpen,
  handleHelpClose,
}: {
  isHelpOpen: boolean;
  handleHelpClose: () => void;
}) {
  return (
    <Modal
      open={isHelpOpen}
      onClose={handleHelpClose}
      size='sm'
      title={t('groups.accessModal.title')}
      subtitle={t('groups.accessModal.subtitle')}
      actions={
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', p: 2 }}>
          <Button
            onClick={handleHelpClose}
            component='button'
            variant='contained'
            sx={{ width: 'auto', px: 3, fontWeight: 'bold' }}
          >
            {t('groups.accessModal.action')}
          </Button>
        </Box>
      }
    >
      <Box sx={{ py: 2, px: 3 }}>
        <Typography
          variant='body1'
          sx={{ textAlign: 'left', mb: 1 }}
        >
          {t('groups.accessModal.subHeader')}
        </Typography>
        <List sx={{ pl: 2 }}>
          <ListItem sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', pl: 0 }}>
            <Typography
              variant='subtitle1'
              sx={{ mb: 0.5 }}
            >
              {t('groups.accessModal.endUser')}
            </Typography>
            <Typography variant='body2'>{t('groups.accessModal.endUserDescription')}</Typography>
          </ListItem>
          <ListItem sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', pl: 0 }}>
            <Typography
              variant='subtitle1'
              sx={{ mb: 0.5 }}
            >
              {t('groups.accessModal.analyst')}
            </Typography>
            <Typography variant='body2'>{t('groups.accessModal.analystDescription')}</Typography>
          </ListItem>
          <ListItem sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', pl: 0 }}>
            <Typography
              variant='subtitle1'
              sx={{ mb: 0.5 }}
            >
              {t('groups.accessModal.supervisor')}
            </Typography>
            <Typography variant='body2'>{t('groups.accessModal.supervisorDescription')}</Typography>
          </ListItem>
          <ListItem sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', pl: 0 }}>
            <Typography
              variant='subtitle1'
              sx={{ mb: 0.5 }}
            >
              {t('groups.accessModal.author')}
            </Typography>
            <Typography variant='body2'>{t('groups.accessModal.authorDescription')}</Typography>
          </ListItem>
        </List>
      </Box>
    </Modal>
  );
}
